import { render, staticRenderFns } from "./vOrderList.vue?vue&type=template&id=1070b124&"
import script from "./vOrderList.vue?vue&type=script&lang=js&"
export * from "./vOrderList.vue?vue&type=script&lang=js&"
import style0 from "./vOrderList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports